module.exports = {"header":{"actions":{"download":{"filename":"hoa_don"}},"top-left":{"checked":"Đã xác thực thông tin doanh nghiệp chính xác","unchecked":"Thông tin doanh nghiệp chưa được xác thực","error":{"address":"Địa chỉ doanh nghiệp không đúng.","name":"Tên doanh nghiệp không đúng.","tax":"Mã số thuế không đúng với giấy phép kinh doanh."},"actions":{"verify":"Bấm để xác thực","loading":"Đang xác thực"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/vi/viewer.json
// module id = 3I2k
// module chunks = 23